export const FORMAT_SELECTION = Object.freeze({
  STANDARD: 'standard',
  EPUB: 'epub',
  BRONTE_VIEWER: 'bronteViewer',
  EPUB_THREELEVEL: 'epub3level',
  CHANNEL_PARTNERS_EPUB: 'channelPartnersePub',
  INDESIGN: 'inDesign',
});

export const VIEW_SELECTION = Object.freeze({
  LESSON: 'lesson',
  SCREEN: 'screen',
});

export const VIEWS = Object.freeze({
  PREVIEW: 'preview',
  EPUB: 'epub-reader',
});

export const EXPORT_TYPE = Object.freeze({
  EPUB_CP_PREVIEW: 'EPUB_CP_PREVIEW',
  IN_DESIGN_PREVIEW: 'IN_DESIGN_PREVIEW',
});
